import React from 'react'
import { useTrans } from 'hooks'
import { Page, RecuperaPasswordLayout } from 'components/organisms'
import styles from './RecuperaPasswordTemplate.module.sass'
import { Button, FormikField, FormLayout } from '@components/atoms'
import { Form, Formik } from 'formik'
import { useRecuperaPasswordMutation } from '@gql/graphql'
import { useRouter } from 'next/router'
import { recuperaPasswordValidationSchema } from '@utils/validationSchemas'
import { handleRescuePasswordTracking } from '@utils/tracking'

interface Props {
  pagina?: any
}

const RecuperaPasswordTemplate = (props: Props) => {
  const { pagina = {} } = props

  const t = useTrans()
  const router = useRouter()
  const [recuperaPassword] = useRecuperaPasswordMutation()
  const initialValues = {
    email: '',
  }

  const handleRecoverPassword = async (values) => {
    if (!values.email) return
    const { data } = await recuperaPassword({
      variables: {
        email: values.email,
      },
    })

    if (data.recuperaPassword.status) {
      handleRescuePasswordTracking('step2_send', 'ok')
      router.push(`/login/recover-password/thank-you/?status=${data?.recuperaPassword?.statusCode}`)
    } else {
      handleRescuePasswordTracking('step2_send', 'ko')
    }
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <RecuperaPasswordLayout pagina={pagina}>
        <Formik
          validationSchema={recuperaPasswordValidationSchema(t)}
          initialValues={initialValues}
          onSubmit={(values) => {
            handleRecoverPassword(values)
          }}
        >
          {(formikProps) => (
            <Form className={styles.formLayout}>
              <FormLayout>
                <FormikField
                  formik={formikProps}
                  id={'recover_email'}
                  name="email"
                  type="email"
                  label={t('Indirizzo email')}
                  placeholder={t('Inserisci il tuo indirizzo email')}
                  required
                  layout="full"
                />
              </FormLayout>
              <Button type="submit" label={t('Invia')} size="lg" className={styles.cta} />
            </Form>
          )}
        </Formik>
        <div className={styles.requirements}>* {t('Campi obbligatori')}</div>
      </RecuperaPasswordLayout>
    </Page>
  )
}

export default RecuperaPasswordTemplate
